<template>
  <v-container fluid style="height: 100%;">
    <v-row align="start" justify="center">
      <v-col lg="8" md="8" sm="12" xs="12" cols="12">
        <v-row>
          <v-col lg="12" style="font-weight: 100;">
            <h4 style="font-weight: 100;">{{ $t("editTrip").toUpperCase() }}</h4>
          </v-col>
        </v-row>
        <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: left;">{{ $t("nameOfTheTrip") }}</p>
                <v-text-field
                  :label="$t('nameOfTheTrip')"
                  v-model="nameTrip"
                  :rules="nameTripRules"
                  solo
                  required
                  append-icon="mdi-directions"
                ></v-text-field>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: left;">{{ $t("pathName") }}</p>
                <v-text-field
                  :label="$t('pathName')"
                  :rules="pathNameRules"
                  v-model="pathName"
                  solo
                  required
                ></v-text-field>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: left;">{{ $t("vehicle") }}</p>
                <v-autocomplete
                  :label="$t('vehicle')"
                  v-model="vehicle"
                  :rules="vehicleRules"
                  :items="vehiclesCarrier"
                  item-text="MovilId"
                  :filter="customFilter"
                  hide-no-data
                  hide-selected
                  clearable
                  solo
                  required
                  append-icon="mdi-truck"
                ></v-autocomplete>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: left;">{{ $t("operator") }}</p>
                <v-autocomplete
                  :label="$t('operator')"
                  v-model="operator"
                  :rules="operatorRules"
                  :items="listOperators"
                  item-value="id"
                  item-text="Operator"
                  :filter="customFilterOP"
                  hide-no-data
                  hide-selected
                  clearable
                  solo
                  required
                  append-icon="mdi-account"
                ></v-autocomplete>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: left;">{{ $t("origin") }}</p>
                <v-text-field
                  :label="$t('origin')"
                  v-model="origin"
                  :rules="originRules"
                  solo
                  required
                  append-icon="mdi-arrow-right"
                ></v-text-field>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: left;">{{ $t("destination") }}</p>
                <v-text-field
                  :label="$t('destination')"
                  v-model="destination"
                  :rules="destinationRules"
                  solo
                  required
                  append-icon="mdi-map-marker"
                ></v-text-field>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: start;">{{ $t("start") }}</p>
                <v-menu
                  offset-x
                  :close-on-content-click="false"
                  :min-width="290"
                  style="width:100%;"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDateTravel"
                      style="width: 100%;padding-right: 5px;"
                      solo
                      readonly
                      :label="$t('startDate')"
                      append-icon="mdi-arrow-right"
                      :color="colorTheme"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    style="min-width: 290px; display: grid;"
                    v-model="startDate2"
                    no-title
                    :min="minDate"
                    :max="maxDate"
                    :color="colorTheme"
                    :locale="this.$i18n.locale"
                  ></v-date-picker>
                  <v-card style="max-width: 290px;">
                    <div style="display: table-cell; padding-right: 10px; padding-left: 20px">
                      <v-select
                        :color="colorTheme"
                        :item-color="colorTheme"
                        style="width: 70px;"
                        :items="Hours"
                        v-model="startTime.selectHour"
                      ></v-select>
                    </div>
                    <div style="display: table-cell; padding-right: 10px;">
                      <label>:</label>
                    </div>
                    <div style="display: table-cell; padding-right: 10px;">
                      <v-select
                        :color="colorTheme"
                        :item-color="colorTheme"
                        style="width: 70px;"
                        v-model="startTime.selectMin"
                        :items="Minutes"
                      ></v-select>
                    </div>
                    <div style="display: table-cell;">
                      <v-select
                        :color="colorTheme"
                        :item-color="colorTheme"
                        style="width: 57px;"
                        v-model="startTime.selectMode"
                        :items="ampm"
                      ></v-select>
                    </div>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12">
                <p style="text-align: start;">{{ $t("finish") }}</p>
                <v-menu
                  offset-x
                  :close-on-content-click="false"
                  :min-width="290"
                  style="width:100%;"
                >
                  <template v-slot:activator="{ on }">
                    <v-row>
                      <v-checkbox v-model="enaEndDateT" :color="colorTheme" hide-details></v-checkbox>
                      <v-text-field
                        v-model="endDateTravel"
                        style="padding-right: 5px;"
                        :disabled="!enaEndDateT"
                        solo
                        readonly
                        :label="$t('startDate')"
                        append-icon="mdi-calendar-blank"
                        :color="colorTheme"
                        v-on="on"
                      ></v-text-field>
                    </v-row>
                  </template>
                  <v-date-picker
                    style="min-width: 290px; display: grid;"
                    v-model="endDate2"
                    no-title
                    :min="maxDate"
                    :color="colorTheme"
                    :locale="this.$i18n.locale"
                  ></v-date-picker>
                  <v-card style="max-width: 290px;">
                    <div style="display: table-cell; padding-right: 10px; padding-left: 20px">
                      <v-select
                        :color="colorTheme"
                        :item-color="colorTheme"
                        style="width: 70px;"
                        :items="Hours"
                        v-model="endTime.selectHour"
                      ></v-select>
                    </div>
                    <div style="display: table-cell; padding-right: 10px;">
                      <label>:</label>
                    </div>
                    <div style="display: table-cell; padding-right: 10px;">
                      <v-select
                        :color="colorTheme"
                        :item-color="colorTheme"
                        style="width: 70px;"
                        v-model="endTime.selectMin"
                        :items="Minutes"
                      ></v-select>
                    </div>
                    <div style="display: table-cell;">
                      <v-select
                        :color="colorTheme"
                        :item-color="colorTheme"
                        style="width: 57px;"
                        v-model="endTime.selectMode"
                        :items="ampm"
                      ></v-select>
                    </div>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-spacer></v-spacer>
        <v-row align="center" justify="center">
          <v-col lg="2">
            <v-btn
              :color="colorTheme"
              class="white--text"
              v-on:click="cancelTravel()"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
          </v-col>
          <v-col lg="2">
            <v-btn
              :color="colorTheme"
              class="white--text"
              v-on:click="addTravel()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "addTravel",
  data() {
    return {
      valid: true,
      nameTrip: "",
      nameTripRules: [v => !!v || this.$t("required")],
      pathName: "",
      pathNameRules: [v => !!v || this.$t("required")],
      vehicle: null,
      vehicleRules: [v => !!v || this.$t("required")],
      operator: null,
      operatorRules: [v => !!v || this.$t("required")],
      origin: "",
      originRules: [v => !!v || this.$t("required")],
      destination: "",
      destinationRules: [v => !!v || this.$t("required")],
      startTime: {},
      endTime: {},
      IdTrip: 0
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", this.$t("traffic"));
    this.$store.commit("setPageHeader", [this.$t("travels"), "", "", "", true]);
    this.$store.commit("setValuesTravel");
    this.$store.dispatch("ListofOperators");
    //this.startTime = this.$store.state.startTime2;
    //this.endTime = this.$store.state.endTime2;
    //console.log(this.$store.state.endDate2);
    //console.log(this.$store.state.startDate2);
  },
  watch: {
    startTime: {
      deep: true,

      handler() {
        this.$store.commit("selectedTime2", ["start", this.startTime]);
      }
    },
    endTime: {
      deep: true,
      handler() {
        this.$store.commit("selectedTime2", ["end", this.endTime]);
      }
    }
  },
  mounted() {
    this.$store.dispatch("ListVehiclesCarrier");
    var Trip = this.$store.state.editTravel;
    // console.log(this.$store.state.editTravel);
    this.IdTrip = Trip.info.TripId;
    this.nameTrip = Trip.info.travelName;
    this.pathName = Trip.info.pathName;
    this.vehicle = Trip.info.vehicle;
    this.operator = Trip.info.DriverId;
    this.origin = Trip.info.origin;
    this.destination = Trip.info.destination;
    this.$store.state.startDateTravel = Trip.info.start;
    var dateFormat = moment(Trip.info.start, "DD/MM/YYYY HH:mm").format();
    // this.startDate2 = moment(dateFormat).format("MM/DD/YYYY");
    this.startTime.selectHour = moment(dateFormat).format("h");
    this.startTime.selectMin = moment(dateFormat).format("mm");
    this.startTime.selectMode = moment(dateFormat).format("a");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "maxDate",
      "minDate",
      "ampm",
      "Minutes",
      "Hours",
      "vehiclesCarrier",
      "valueDeterminate",
      "listOperators"
    ]),
    startDateTravel: {
      get: function() {
        return this.$store.state.startDateTravel;
      },
      set: function(value) {}
    },
    endDateTravel: {
      get: function() {
        return this.$store.state.endDateTravel;
      },
      set: function(value) {}
    },
    endDate2: {
      get: function() {
        return this.$store.state.endDate2;
      },
      set: function(value) {
        this.$store.commit("startDateTravel", ["end", value]);
      }
    },
    startDate2: {
      get: function() {
        return this.$store.state.startDate2;
      },
      set: function(value) {
        this.$store.commit("startDateTravel", ["start", value]);
      }
    },
    enaEndDateT: {
      get: function() {
        return this.$store.state.enaEndDateT;
      },
      set: function(value) {
        this.$store.commit("enaEndDateT", value);
      }
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const textOne = item.MovilId.toLowerCase();
      const textTwo = item.Nick.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    customFilterOP(item, queryText, itemText) {
      const textOne = item.Operator.toLowerCase();
      const textTwo = item.License.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    cancelTravel() {
      this.$router.replace({ name: "traffic" });
    },
    addTravel() {
      if (this.$refs.form.validate()) {
        var startDate = this.$store.state.startDateTravel;
        if (!this.enaEndDateT) {
          var starTime = moment(startDate, "DD/MM/YYYY h:mma");
          var currentTime = moment();
          //var stillUtc = moment.utc(startDate);
          //var stillFormat = moment(stillUtc).format("DD/MM/YYYY HH:mm");
          if (starTime.isBefore(currentTime)) {
            var items = {
              Id: this.IdTrip,
              DriverId: this.operator,
              VehicleId: this.vehicle,
              TripName: this.nameTrip,
              Origin: this.origin,
              Destination: this.destination,
              RouteName: this.pathName,
              StartDate: starTime
            };
            //   console.log(items);
            this.$store.dispatch("EditTrip", items);
          } else {
            this.$store.commit("snackbar", {
              snackbar: true,
              text: i18n.t("currentlimitTime")
            });
          }
        } else {
          startDate = this.$store.state.startDateTravel;
          var endDate = this.$store.state.endDateTravel;
          var datestart = moment(startDate, "DD/MM/YYYY h:mma");
          var dateEnd = moment(endDate, "DD/MM/YYYY h:mma");
          //var stillUtcStart = moment.utc(startDate).format("DD/MM/YYYY HH:mm");
          //console.log(stillUtcStart);
          //var stillUtcEnd = moment.utc(endDate).format("DD/MM/YYYY HH:mm");
          //console.log(stillUtcEnd);
          if (datestart.isBefore(dateEnd)) {
            var diff = moment(dateEnd).diff(datestart, "days");
            if (diff < 7) {
              var items = {
                Id: this.IdTrip,
                DriverId: this.operator,
                VehicleId: this.vehicle,
                TripName: this.nameTrip,
                Origin: this.origin,
                Destination: this.destination,
                RouteName: this.pathName,
                StartDate: datestart,
                EndDate: dateEnd
              };
              //  console.log(items);
              this.$store.dispatch("EditTrip", items);
            } else {
              this.$store.commit("snackbar", {
                snackbar: true,
                text: i18n.t("dateRange")
              });
            }
          } else {
            this.$store.commit("snackbar", {
              snackbar: true,
              text: i18n.t("lessStartDate")
            });
          }
        }
      }
    }
  }
};
</script>
